import React, { Component } from "react";
import LookbookListView from "presentational/lookbook/LookbookListView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";

class RootLookbook extends Component {
  initLookbookList = async () => {
    const { FollowingsOutfitActions, AppErrorActions, getIdTokenWT } =
      this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await FollowingsOutfitActions.initList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  requestLookbookList = async () => {
    const { FollowingsOutfitActions, AppErrorActions, getIdTokenWT } =
      this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await FollowingsOutfitActions.requestNextList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  render() {
    const { isLoading, isEnd, outfitList } = this.props;

    return (
      <LookbookListView
        list={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
        callNextListFn={this.requestLookbookList}
      />
    );
  }

  componentDidMount() {
    this.initLookbookList();
  }
}

export default withToken(
  withStore({
    stateMap: { followingsOutfit: ["outfitList", "isLoading", "isEnd"] },
    dispatchMap: ["followingsOutfit", "appError"]
  })(RootLookbook)
);
